import { Root } from "./SubpageMain.css";

export default function SubpageMain({ children }: subpageProps) {
   return <Root>{children}</Root>;
}

interface subpageProps {
   children: React.ReactNode;
}
